import { MealOfDayDivision, Nutrient } from '@/api/types'
import { SORTED_MEALS as SORTED_MEALS_SRC, MEAL_PARTS as MEAL_PARTS_SRC } from '../constants'

export const SORTED_MEALS = SORTED_MEALS_SRC

export const MACROS = ['PROTEIN', 'CARB', 'FAT'] as const
export const MICRO_NUTRIENTS: Nutrient[] = ['FIBER', 'CHOLESTEROL', 'SALT'] as const

export const DAYS_OF_WEEK = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
] as const

export const DAYS_OF_WEEK_JS: Array<DayOfWeek> = [
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
]

export type DayOfWeek = (typeof DAYS_OF_WEEK)[number]

export const MEAL_PARTS = MEAL_PARTS_SRC

export const NUTRIENT_MAPPING = {
  KCAL: 'energy',
  PROTEIN: 'protein',
  FAT: 'fat',
  CARB: 'carbohydrate',
  FIBER: 'fiber',
  CHOLESTEROL: 'cholesterol',
  IRON: 'iron',
  SALT: 'salt',
} as const

export const NUTRIENT_UNITS = {
  KCAL: 'kcal',
  PROTEIN: 'g',
  FAT: 'g',
  CARB: 'g',
  FIBER: 'g',
  CHOLESTEROL: 'mg',
  IRON: 'mg',
  SALT: 'g',
} as const

export const DEFAULT_MEAL_DIVISIONS: MealOfDayDivision[] = [
  {
    idMealOfDayDivision: 1,
    mealOfDay: 'BREAKFAST',
    type: 'MEAL_PART',
    mealPart: 'BREAKFAST',
  },
  {
    idMealOfDayDivision: 2,
    mealOfDay: 'MIDDLE_MORNING',
    type: 'MEAL_PART',
    mealPart: 'SNACK',
  },
  {
    idMealOfDayDivision: 3,
    mealOfDay: 'LUNCH',
    type: 'MEAL_PART',
    mealPart: 'SIDE_DISH',
  },
  {
    idMealOfDayDivision: 4,
    mealOfDay: 'LUNCH',
    type: 'MEAL_PART',
    mealPart: 'LUNCH',
  },
  {
    idMealOfDayDivision: 5,
    mealOfDay: 'MIDDLE_AFTERNOON',
    type: 'MEAL_PART',
    mealPart: 'SNACK',
  },
  {
    idMealOfDayDivision: 6,
    mealOfDay: 'DINNER',
    type: 'MEAL_PART',
    mealPart: 'DINNER',
  },
  {
    idMealOfDayDivision: 7,
    mealOfDay: 'AFTER_DINNER',
    type: 'MEAL_PART',
    mealPart: 'SNACK',
  },
]
